import type React from 'react';

import { Wrapper } from './wrapper';

export type BadgeToneProps =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'disabled'
  | 'ghost'
  | 'contrast';

interface Props {
  children: React.ReactNode;
  tone?: BadgeToneProps;
  size?: 'small';
  noWrap?: boolean;
  bleedBlock?: boolean;
  cursor?: HTMLDivElement['style']['cursor'];
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const Badge = ({ children, tone, size, noWrap, bleedBlock, cursor, onClick }: Props) => (
  <Wrapper
    $tone={tone}
    $size={size}
    $noWrap={noWrap}
    $bleedBlock={bleedBlock}
    $cursor={cursor}
    onClick={onClick}
  >
    {children}
  </Wrapper>
);

export default Badge;
